import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import MainScreen from "./MainScreen";
import PrivacyPolicy from "../Authentication/PrivacyPolicy";
import TermsOfService from "../Authentication/TermsOfService";
import AuthAction from "../Authentication/AuthAction/AuthAction";
import CoursePage from "./Courses/CoursePage";
import BooksPage from "./Books/BooksPage";
import BookViewPage from "./Books/BookViewPage";

const MainStack: React.FC = () => {
  return (
    <div className="mainWrapper">
      <Header />

      <Routes>
        <Route path="/" element={<MainScreen />} />
        <Route path="/courses" element={<CoursePage />} />
        <Route path="/books" element={<BooksPage />} />
        <Route path="/book-view" element={<BookViewPage />} />
        <Route path="/auth/action" element={<AuthAction />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>

      <Footer />
    </div>
  );
};

export default MainStack;